import { isAfter, isBefore } from "@hex-insights/core";
import { Announcement, AnnouncementNameFragment } from "../../../Utilities";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: AnnouncementNameFragment) {
	if (!instance.title) {
		return "Announcement";
	}

	return Fields.title(instance.title);
}

export function status(instance: Pick<Announcement, "startTime" | "endTime">) {
	if (isBefore(new Date(), new Date(instance.startTime))) {
		return "Upcoming";
	}
	if (!!instance.endTime && isAfter(new Date(), new Date(instance.endTime))) {
		return "Expired";
	}
	return "Live";
}
